import { DatePipe } from '@angular/common';
import { Component, OnInit, ViewChild } from '@angular/core';
import { MediaObserver } from '@angular/flex-layout';
import { AuthenticatedUser, AuthenticationService } from '@aveva/connect-web-core';
import { firstValueFrom } from 'rxjs';
import { Available } from 'src/app/models/available.model';
import { AccountsService } from 'src/app/services/accounts.service';
import * as XLSX from 'xlsx';
import * as globals from '../globals';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { LoggingService } from '../../services/logging.service';

@Component({
  standalone: false,
  selector: 'app-home',
  templateUrl: './home.component.html',
  styleUrls: ['./home.component.css']
})
export class HomeComponent implements OnInit {

  constructor(
    private datePipe: DatePipe,
    public media: MediaObserver,
    private authenticationService: AuthenticationService,
    private accountsService: AccountsService,
    private logger: LoggingService) { }

  ngOnInit(): void {
    this.isContributor = ([`${globals.TC}:${globals.trainingadmin}`, `${globals.TC}:${globals.trainer}`].includes(localStorage.getItem(globals.POLICIES)));
    this.getAccounts();    
  }

  private async getAccounts() {
    try {
      this.logger.logEvent('Accounts Fetch Initiated');
      this.loadingSpinner(true);    
      this.user = await this.authenticationService.getUser();
      const availabilities = await firstValueFrom(this.accountsService.getAccountsAvailable(this.user?.email));
      this.dataSource = new MatTableDataSource(availabilities);
      this.loadingSpinner(false);
    }
    catch (exception) {
      this.logger.logException(exception);
      this.loadingSpinner(false);
    }
  }

  async exportDataToExcel() {
    const uniqueValue = this.datePipe.transform(new Date(),globals.exportFile_dateFormat).toString();
    const fileName = `${globals.exportFile_name}_${uniqueValue}.xlsx`;

    /* pass here the table id */
    const ws: XLSX.WorkSheet = XLSX.utils.json_to_sheet(this.dataSource.data);
    /* generate workbook and add the worksheet */
    const wb: XLSX.WorkBook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(wb, ws, globals.exportFile_sheetName);
    /* save to file */
    XLSX.writeFile(wb, fileName);

    this.logger.logEvent('Accounts Export Success', {fileName: fileName});
  }

  isMobile = () => window.matchMedia('(max-width: 840px)').matches;

  loadingSpinner = (value: boolean) => this.isLoading = value;

  isContributor: boolean;
  user: AuthenticatedUser;
  isLoading: boolean;
  displayedColumns: string[] = globals.availabilities_columns;
  dataSource = new MatTableDataSource<Available>();

  @ViewChild(MatSort) set matSort(sort: MatSort) {
    this.dataSource.sort = sort;
  }
}
